<template>
	<div style="display:flex">
		<div style="width:900px;">

			<!-- 点击客房管理房态图进入详情 -->
			<!-- <el-button size="mini" @click="returnClick" class="return">返回</el-button> -->
			<section>
				<div class="one">
					<Carousel :isKan="isKan" :ceshi="ceshi" :customerRoomItem="customerRoomItem"
						addUrl="/api/roomManage/addLabel"></Carousel>
				</div>
				<!-- <div class="two">
				</div> -->
			</section>


			<section>
				<div class="one">
					<el-tabs v-model="activeName" type="border-card">
						<el-tab-pane label="已入住人才" name="first">
							<el-table :data="checkedInTalentList" style="width: 100%" height="304px"
								:header-cell-style="{ background: '#f8f9fa', color: '#666666' }">
								<el-table-column prop="name" label="人才姓名" align="center">
								</el-table-column>
								<el-table-column prop="talentLevel" label="人才级别" align="center">
									<template slot-scope="{row}">
										{{ row.talentLevel == 1 ? '本科' : row.talentLevel == 2 ? '硕士' : row.talentLevel
		== 3 ? '博士' : row.talentLevel == 4 ? '专家' : '海归'
}}
									</template>
								</el-table-column>
								<el-table-column prop="phone" label="联系电话" align="center">
								</el-table-column>
								<!-- <el-table-column prop="checkInTime" label="入住时间" align="center">
							</el-table-column>
							<el-table-column prop="contractTime" label="到期时间" align="center">
							</el-table-column> -->
								<!-- <el-table-column prop="standardServicesList" label="备注(服务要求)" align="center">
								<template slot-scope="scope">
									<span v-for="item in scope.row.standardServicesList">{{item}} ;</span>
								</template>
							</el-table-column> -->
								<!-- <el-table-column prop="checkInStatus" label="入住状态" align="center">
							</el-table-column>

							<el-table-column label="操作" align="center" width="300">
								<template slot-scope="{row}">
									<el-button v-if="row.status=='已过期'||row.status=='即将过期'" size="mini"
										@click="xzClick(row)">续住</el-button>
									<el-button v-if="roleId==1||roleId==2||roleId==5" size="mini"
										@click="tzClick(row)">退住</el-button>
								</template>
							</el-table-column> -->
							</el-table>
						</el-tab-pane>
						<el-tab-pane label="已预订人才" name="second">
							<el-table :data="toBeCheckInTalentList" style="width: 100%" height="304px"
								:header-cell-style="{ background: '#f8f9fa', color: '#666666' }">
								<el-table-column prop="name" label="人才姓名" align="center">
								</el-table-column>
								<el-table-column prop="idCard" label="身份证号" align="center">
									<template slot-scope="{row}">
										<span v-if="row.idCard">
											{{ row.idCard }}
										</span>
										<span v-else>未填写</span>
									</template>
								</el-table-column>
								<el-table-column prop="company" label="任职单位" align="center">
								</el-table-column>
								<el-table-column prop="talentLevel" label="人才级别" align="center">
									<template slot-scope="{row}">
										{{ row.talentLevel == 1 ? '本科' : row.talentLevel == 2 ? '硕士' : row.talentLevel
		== 3 ? '博士' : row.talentLevel == 4 ? '专家' : '海归'
}}
									</template>
								</el-table-column>
								<el-table-column prop="phone" label="手机号" align="center">
								</el-table-column>
								<!-- <el-table-column prop="cohabitFlag" label="是否有同住人" align="center">
							</el-table-column> -->
								<!-- <el-table-column prop="standardServicesList" label="备注(服务要求)" align="center">
								<template slot-scope="scope">
									<span v-for="item in scope.row.standardServicesList">{{item}} ;</span>
								</template>
							</el-table-column> -->
								<!-- <el-table-column label="操作" align="center" width="250">
								<template slot-scope="scope">
									<el-button size="mini" @click="handleCheckIn(scope.row)"
										v-show="roleId==3?false:true">一键入住</el-button>
									<el-button size="mini" @click="handleCancel(scope.row)">取消预订</el-button>
								</template>
							</el-table-column> -->
							</el-table>
						</el-tab-pane>
						<el-tab-pane label="已申请人才" name="third">
							<el-table :data="submittedTalentList" style="width: 100%" height="304px"
								:header-cell-style="{ background: '#f8f9fa', color: '#666666' }">
								<el-table-column prop="name" label="人才姓名" align="center">
								</el-table-column>
								<el-table-column prop="idCard" label="身份证号" align="center">
								</el-table-column>
								<el-table-column prop="company" label="任职单位" align="center">
								</el-table-column>
								<el-table-column prop="talentLevel" label="人才级别" align="center">
									<template slot-scope="{row}">
										{{ row.talentLevel == 1 ? '本科' : row.talentLevel == 2 ? '硕士' : row.talentLevel
		== 3 ? '博士' : row.talentLevel == 4 ? '专家' : '海归'
}}
									</template>
								</el-table-column>
								<el-table-column prop="phone" label="手机号" align="center">
								</el-table-column>
								<!-- 							<el-table-column prop="cohabitFlag" label="是否有同住人" align="center">
							</el-table-column>
						

							<el-table-column label="操作" align="center" width="150">
								<template slot-scope="scope">
									<el-button size="mini" @click="handleCheckIn(scope.row)">{{roleId==3?'一键预订':'一键入住'}}
									</el-button>
									
								</template>
							</el-table-column> -->
							</el-table>
						</el-tab-pane>
					</el-tabs>
				</div>

				<!--<div class="two">
			 <el-tabs v-model="expenseActive" type="border-card">
					<el-tab-pane label="个人账单" name="expenseOne">
						<el-table :data="expenseTableData" style="width: 100%">
							<el-table-column prop="date" label="日期" sortable width="180">
							</el-table-column>
							<el-table-column prop="name" label="姓名" width="180">
							</el-table-column>
							<el-table-column prop="tag" label="类别" width="100"
								:filters="[{ text: '家', value: '家' }, { text: '公司', value: '公司' }]"
								:filter-method="filterTag" filter-placement="top-end">
							</el-table-column>
							<el-table-column prop="fee" label="费用" sortable>
							</el-table-column>
							<el-table-column prop="address" label="备注" :formatter="formatter">
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane label="单位账单" name="expenseTwo">
						<el-table :data="expenseTableData" style="width: 100%">
							<el-table-column prop="date" label="日期" sortable width="180">
							</el-table-column>
							<el-table-column prop="name" label="姓名" width="180">
							</el-table-column>
							<el-table-column prop="tag" label="类别" width="100"
								:filters="[{ text: '家', value: '家' }, { text: '公司', value: '公司' }]"
								:filter-method="filterTag" filter-placement="top-end">
							</el-table-column>
							<el-table-column prop="fee" label="费用" sortable>
							</el-table-column>
							<el-table-column prop="address" label="备注" :formatter="formatter">
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs> 
				</div>-->
			</section>
		</div>
		<div style="width:90%;margin-left: 10px;margin-top: 20px;">
			<div class="one">
				<el-tabs type="border-card">
					<el-table :data="submittedTalentList" style="width: 100%"
						:header-cell-style="{ background: '#f8f9fa', color: '#666666' }">
						<el-table-column prop="name" label="服务类型" align="center">
						</el-table-column>
						<el-table-column prop="name" label="服务结果" align="center">
						</el-table-column>
						<el-table-column prop="name" label="服务内容" align="center">
						</el-table-column>
						<el-table-column prop="name" label="评价" align="center">
						</el-table-column>
					</el-table>
				</el-tabs>
			</div>

		</div>
		<el-dialog :append-to-body="true" :close-on-click-modal='false' :visible.sync="isXz" width="30%" title="续住">
			<el-form :model="formXz">
				<el-form-item label="入住期限">
					<el-select v-model="formXz.checkDate">
						<el-option label="一年" value="一年"></el-option>
						<el-option label="两年" value="两年"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入住证明">
					<el-upload action="/api/admin/checkInApply/uploadApply" :on-success="handleAvatarSuccess"
						name="file" :headers="headerData" :on-remove="removeFile" :multiple="false"
						:on-preview="handlePictureCardPreview" :file-list="formXz.showApplyPathList">
						<el-button size="small" type="primary">上传入住证明</el-button>
						<div class="el-upload__tip" slot="tip">请上传申报文件，支持格式JPG、JPEG、PNG、pdf</div>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="xzQd">确定</el-button>
					<el-button @click="cancleXz">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import Carousel from '../../../components/Carousel.vue'

export default {
	data() {
		return {
			tableData: [],
			isKan: null,
			isShow: false,
			ceshi: false,
			isTalent: null, //是否是人才申请时进入
			customerRoomItem: {}, //客房详情数据,
			id: null, //客房id
			isXz: false,
			formXz: {
				userId: null,
				checkDate: ''
			},
			oldFormXz: {},
			headerData: {
				Authorization: localStorage.access_token
			},
			checkedInTalentList: [], //已入住
			submittedTalentList: [], //待入住
			toBeCheckInTalentList: [], //已预订
			roleId: sessionStorage.getItem("roleId"), //角色id
			activeName: "first", //已入住、待入住、已预约
			expenseActive: "expenseOne",
			expenseTableData: [{
				date: '2016-05-02',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1518 弄',
				tag: '家',
				fee: 12,
			}, {
				date: '2016-05-04',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1517 弄',
				tag: '公司',
				fee: 12,
			}, {
				date: '2016-05-01',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1519 弄',
				tag: '家',
				fee: 2,
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄',
				tag: '公司',
				fee: 123,
			}]
		}
	},
	components: {
		Carousel
	},
	mounted() {
		this.oldFormXz = JSON.parse(JSON.stringify(this.formXz))
		let a = this.$route.params
		this.isKan = this.$route.params.ceshi
		console.log(a)
		this.id = sessionStorage.getItem('id') * 1;

		// if (sessionStorage.getItem("isTalent")) {
		// 	this.isTalent = true;
		// } else {
		// 	this.isTalent = false;
		// }

		this.getRoomDetail();
		this.getRoomTalent();
	},
	beforeRouteEnter(to, from, next) {
		console.log(from);
		if (from.fullPath == "/index/apartment/customerInformation") {
			console.log("进来了")
			next(vm => {
				vm.ceshi = false
			});
		} else {
			next(vm => {
				vm.ceshi = true
			});
		}
	},

	methods: {
		// 获取房间详情
		getRoomDetail() {
			this.$http.get("/api/roomManage/getOneRoom?id=" + this.id).then(res => {
				if (!res.data.data.vipLevel) {
					res.data.data.vipLevel = "1级"
				}
				this.customerRoomItem = res.data.data;
			})
		},
		// 获取该房间的所有人才
		getRoomTalent() {
			this.$http.get("/api/roomManage/getRoomTalent?id=" + this.id).then(res => {
				console.log("xx", res);
				this.checkedInTalentList = res.data.data.checkedInTalentList;
				// this.checkedInTalentList.forEach(item => {
				// 	if (item.checkInTime != null) {
				// 		item.checkInTime = item.checkInTime.split("T")[0];
				// 	}
				// 	if (item.talentLevel == 1) {
				// 		item.oldTalentLevel = "本科"
				// 	}
				// 	if (item.talentLevel == 2) {
				// 		item.oldTalentLevel = "硕士"
				// 	}
				// 	if (item.talentLevel == 3) {
				// 		item.oldTalentLevel = "博士"
				// 	}
				// 	if (item.talentLevel == 4) {
				// 		item.oldTalentLevel = "专家"
				// 	}
				// 	if (item.talentLevel == 5) {
				// 		item.oldTalentLevel = "海归"
				// 	}
				// })
				this.submittedTalentList = res.data.data.submittedTalentList;
				this.toBeCheckInTalentList = res.data.data.toBeCheckInTalentList;
				console.log(this.submittedTalentList);

			})
		},
		// 一键入住
		handleCheckIn(row) {
			console.log(row);
			this.$http.post("/api/roomManage/checkInRoom", {
				roomId: this.id,
				userId: row.userId,
			}).then(res => {
				console.log(66, res);
				this.getRoomTalent();
			})
		},

		// 取消预订
		handleCancel(row) {
			this.$http.get("/api/roomManage/cancelSubscribe?userId=" + row.userId).then(res => {
				this.getRoomTalent();
			})
		},

		formatter(row, column) {
			return row.address;
		},
		filterTag(value, row) {
			return row.tag === value;
		},
		handleAvatarSuccess(response, file, fileList) {
			console.log(fileList);
			this.detailFileList(fileList);
		},
		handlePictureCardPreview(file) {
			window.open(file.url, '_target');
		},
		// 上传申报文件
		detailFileList(fileList) {
			this.formXz.showApplyPathList = [];
			this.formXz.applyPathList = [];
			fileList.forEach((item) => {
				if (item.hasOwnProperty('response')) {
					this.formXz.showApplyPathList.push({
						name: item.name,
						url: item.response.data.showPath
					})
					this.formXz.applyPathList.push({
						name: item.name,
						url: item.response.data.filePath
					});
				} else {
					this.formXz.showApplyPathList.push({
						name: item.name,
						url: item.url
					});
					this.formXz.applyPathList.push({
						name: item.name,
						url: item.url
					});
				}
			})
			console.log(this.formXz);
		},
		// 删除文件
		removeFile(file, fileList) {
			let newFileList = [];
			let newFileList2 = [];
			this.formXz.applyPathList.forEach(item1 => {
				fileList.forEach(item2 => {
					if (item1.url == item2.response.data.filePath) {
						newFileList.push({
							name: item1.name,
							url: item1.url,
						});
					}
				})
			})
			this.formXz.showApplyPathList.forEach(item1 => {
				fileList.forEach(item2 => {
					if (item1.url == item2.response.data.showPath) {
						newFileList2.push({
							name: item1.name,
							url: item1.url,
						})
					}
				})
			})
			this.formXz.applyPathList = JSON.parse(JSON.stringify(newFileList));
			this.formXz.showApplyPathList = JSON.parse(JSON.stringify(newFileList2));
		},
		// 上传文件
		beforeAvatarUpload(file) {
			console.log(file);
			var isJPG = null;
			if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type ===
				'application/pdf') {
				isJPG = true;
			} else {
				isJPG = false;
			}
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isJPG) {
				this.$message.error('上传申报文件只能是 JPG/JPEG/PNG/pdf 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 1MB!');
			}
			// var uploadFlag = true;
			// if (this.applyPathList.length >= 2) {
			// 	uploadFlag = false;
			// 	this.$message.error("上传图片最多为两个，请先删除，在上传")
			// }
			return isLt2M && isJPG
		},
		cancleXz() {
			this.formXz = JSON.parse(JSON.stringify(this.oldFormXz))
			this.isXz = false
		},
		xzQd() { //续住
			// 申报文件
			if (this.formXz.applyPathList == null) {
				this.formXz.applyPathList = [];
			}
			let files3 = [];
			this.formXz.applyPathList.forEach(item => {
				files3.push(item.url);
			})
			this.formXz.applyPathList = JSON.parse(JSON.stringify(files3));
			if (this.formXz.showApplyPathList == null) {
				this.formXz.showApplyPathList = [];
			}
			let files4 = [];
			this.formXz.showApplyPathList.forEach(item => {
				files4.push(item.url);
			})
			this.formXz.showApplyPathList = JSON.parse(JSON.stringify(files4));
			console.log(this.formXz)
			this.$http.post("/api/roomManage/continueToLive", {
				...this.formXz
			}).then(res => {
				if (res.data.code == 0) {
					this.$message.success(res.data.message)
					this.isXz = false
					this.getRoomTalent()
				} else {
					this.$message.warning(res.data.message)
				}
				console.log(res)
			}).catch(err => {
				console.log(err)
			})
		},
		xzClick(val) {
			this.formXz.userId = val.userId
			this.isXz = true
		},
		tzClick(val) {//退住
			this.$http.get(`/api/roomManage/checkOutRoom?userId=${val.userId}`).then(res => {
				console.log(res)
				if (res.data.code == 0) {
					this.$message.success(res.data.message)
					this.getRoomTalent()
				} else {
					this.$message.warning(res.data.message)
				}
			}).catch(err => {
				console.log(err)
			})
		}
	},

}
</script>

<style scoped="scoped">
.return {
	margin: 20px;
}

.roomInfor {
	width: 100%;
	border: 1px solid #e7e7ee;
	box-sizing: border-box;
}

.roomTop {
	border-bottom: 1px solid #E7E7EE;
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
}

.roomTop span {
	margin-left: 10px;
	color: #000000;
	font-weight: bold;
}

section {
	width: 100%;
	display: flex;
	justify-content: space-evenly;
	margin: 20px 0;
}

section .one {
	width: 100%;
}

section .two {
	width: 48%;

}

.columnNav {
	display: flex;
	position: relative;
	background-color: #70757B;
	height: 60px;
	line-height: 60px;
	margin-bottom: 20px;
}

.columnNav p {
	color: white;
	margin-left: 15px;
}

span {}
</style>
